<template>
  <div>
    <b-modal :active.sync="isModalActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">入力タイプの選択</p>
        </header>
        <section class="modal-card-body">
          <b-field label="入力タイプ">
            <b-select v-model="selectedType" expanded>
              <option v-for="option in options" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="confirmSelection" type="is-primary">決定</b-button>
          <b-button @click="isModalActive = false">キャンセル</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isModalActive: false,
      selectedType: '1',
      options: [
        { value: '1', label: '自由入力' },
        { value: '2', label: '選択入力' },
        { value: '3', label: '日付入力' }
      ]
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true
    },
    confirmSelection() {
      const selectedOption = this.options.find(option => option.value === this.selectedType);
      this.$emit('selection-confirmed', {
        type: this.selectedType,
        label: selectedOption ? selectedOption.label : null
      });
      this.isModalActive = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Manage/ModalTypeForCustomColumn.vue